<template>
  <v-container>
    <PageHeader :title="name" />

    <v-form ref="form" style="width: 100%">
      <v-card>
        <Subheader title="Manage Continuous Data Databases" no-search></Subheader>
        <v-card-text>
          <v-layout row wrap>
            <template>
              <v-flex xs12 md10 offset-md1>
                <div class="headline">Choose Continuous Data Query Database:</div>
                <div class="font-weight-regular">Data from this database will be used for station and wrdr continuous data queries.</div>
                <v-radio-group v-model="queryDatabase">
                  <v-radio label="AquariusNG" value="AquariusNG"></v-radio>
                </v-radio-group>
              </v-flex>
            </template>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" block @click="agreeSave()" :disabled="cannotSave">
            <v-icon class="mr-1">done</v-icon>
            {{ $t('Button.Save') }}
          </v-btn>
          <v-btn color="secondary" outline dark block @click="$router.push({name: 'accessManage'})">
            {{ $t('Button.Cancel') }}
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-form>

    <PageLoading v-if="showLoading" />

    <app-confirmation-modal v-model="saveFailed" max-width="500">
      <template slot="app-modal-title">
        Save Continuous Data Databases Failed
      </template>
      <template slot="app-modal-text">
        {{ errorMessage }}
      </template>
      <template slot="app-modal-actions">
        <v-spacer></v-spacer>
        <v-btn color="secondary" @click="saveFailed = false" outline>Cancel</v-btn>
      </template>
    </app-confirmation-modal>

    <v-snackbar style="text-align:center" :color="snackColor" :timeout="null" top v-model="snackbar">
      {{ snackMessage }}
      <v-btn dark flat @click.native.stop.prevent="snackbar = false">{{ $t('Button.Close') }}</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
  import PageHeader from '@/components/generic/PageHeader'
  import Subheader from '@/components/generic/Subheader'
  import AppConfirmationModal from '@/components/generic/AppConfirmationModal'
  import PageLoading from '@/components/generic/PageLoading'
  import { createNamespacedHelpers } from 'vuex'
  import SnackBarUtil from '@/components/mixins/SnackBarUtil'
  import SideMenuUtil from '@/components/mixins/SideMenuUtil'
  const admin = createNamespacedHelpers('admin')
  const continuousdbconfig = createNamespacedHelpers('continuousdbconfig')
  const stations = createNamespacedHelpers('stations')
  const authenticate = createNamespacedHelpers('authenticate')
  const CONTINUOUS_QUERY_DATABASE = 'Query'

  export default {
    components: {
      PageHeader,
      Subheader,
      PageLoading,
      'app-confirmation-modal': AppConfirmationModal,
    },
    mixins: [SnackBarUtil, SideMenuUtil],
    props: {
      name: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        queryDatabase: '',
        saveFailed: false,
        errorMessage: '',
        showLoading: false,
      }
    },
    computed: {
      ...admin.mapGetters(['roleList']),
      ...authenticate.mapGetters(['currentUserGroup']),
      ...continuousdbconfig.mapState(['ContinuousDataConfigQueryOption']),
      tenantData() {
        return this.roleList.find(x => x.RoleName == this.name)
      },
      tenantId() {
        return this.tenantData && this.tenantData.Id
      },
      cannotSave() {
        if (this.ContinuousDataConfigQueryOption.ConfigurationValue == this.queryDatabase) {
          return true
        } else
          return false
      },
    },
    watch: {
      async tenantId() {
        await this.initialize()
      },
    },
    methods: {
      ...admin.mapActions(['getRoleList']),
      ...continuousdbconfig.mapActions(['getContinuousDataConfigQueryOption', 'updateContinuousDataConfigOption']),
      ...stations.mapActions(['getTimeSeriesStations', 'clearRecentStationIdsNavigated']),
      async agreeSave() {
        if (this.queryDatabase) {
          this.showLoading = true
          let options = {
            data: {
              ConfigurationType: CONTINUOUS_QUERY_DATABASE,
              ConfigurationValue: this.queryDatabase,
              TenantId: this.tenantId,
            },
          }
          await this.updateContinuousDataConfigOption(options)
            .then(() => {
              this.continuousStationCategoryChange()
              this.snackMessage = 'Save successfully.'
              this.snackColor = 'success'
              this.snackbar = true
              this.getTimeSeriesStations({ program: this.currentUserGroup.name }).then(() => this.clearRecentStationIdsNavigated())
              setTimeout(() => this.showLoading = false, 500)
            })
            .catch((error) => {
              this.errorMessage = error
              this.saveFailed = true
              setTimeout(() => this.showLoading = false, 500)
            })
        } else {
          this.snackMessage = 'Please select one Query Database.'
          this.snackColor = 'error'
          this.snackbar = true
        }
      },
      async initialize() {
        await this.getContinuousDataConfigQueryOption(this.tenantId)
        this.queryDatabase = this.ContinuousDataConfigQueryOption.ConfigurationValue
      },
    },
    async mounted() {
      await this.initialize()
    },
  }
</script>